var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasImage)?_c('div',{staticClass:"flex items-center"},[_c('div',{staticStyle:{"height":"60px","width":"60px"}},[_c('img',{attrs:{"src":_vm.image,"width":"60"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }